const includeGoogleRecaptchaScript = (d: Document, key: string) => {
  if (d.getElementById(key)) {
    return;
  }

  const firstScriptTag: HTMLElement = d.getElementsByTagName('script')[0];
  const grScriptTag = d.createElement('script');
  const headTag = d.getElementsByTagName('head')[0];
  grScriptTag.id = key;
  grScriptTag.src = `https://www.recaptcha.net/recaptcha/api.js?render=${key}`;

  if (firstScriptTag.parentNode) {
    firstScriptTag.parentNode.insertBefore(grScriptTag, firstScriptTag);
  } else {
    headTag.appendChild(grScriptTag);
  }
};

export default includeGoogleRecaptchaScript;
